export default __webpack_public_path__ + "static/cover-big-norsk-9e27e2668868b9826c45828e7d0c03aa.png";